module.exports = __webpack_public_path__ + "img/notgoodpeople1.3aac7909.jpg";